import styled, { css, keyframes } from 'styled-components';
const ANIMATION_DURATION = 1.5;
const pulseAnimation = keyframes `
  0% {
    transform: scale(0.33);
  }
  80%,
  100% {
    opacity: 0;
  }
`;
const circleAnimation = keyframes `
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
`;
const commonStyles = css `
  content: '';
  display: block;
  border-radius: 100%;
`;
export const Dot = styled.div `
  width: 10px;
  height: 10px;
  position: relative;

  &:before {
    ${commonStyles};
    position: relative;
    width: 250%;
    height: 250%;
    box-sizing: border-box;
    margin-left: -75%;
    margin-top: -75%;
    animation: ${pulseAnimation} ${ANIMATION_DURATION}s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  }

  &:after {
    ${commonStyles};
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    animation: ${circleAnimation} ${ANIMATION_DURATION}s
      cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
  }
`;
export const Label = styled.div `
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.14px;
  margin-top: 2px;
`;
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ color }) => color};

  ${({ color }) => css `
    ${Dot}::before, ${Dot}::after {
      background-color: ${color};
    }
  `};
`;
